import { render, staticRenderFns } from "./weekly-backup.vue?vue&type=template&id=e78b4392"
import script from "./weekly-backup.vue?vue&type=script&lang=js"
export * from "./weekly-backup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports